<template>
  <div class="rounded bg-grey_3 pa-3 mb-4 bordered">
    <div class="text-h5 mb-4 font-weight-bold">
      {{ article.nom }}
      <v-chip color="primary-dark" variant="elevated" elevation="0" density="compact">{{ article.nb_reservations }} commandes</v-chip>
    </div>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="article.nom" label="Nom de l'article"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="article.prix" type="number" label="Prix" append-inner-icon="mdi-currency-eur"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-textarea v-model="article.description" label="Description" rows="3"></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-switch v-model="article.visible_accueil" hide-details true-value="1" false-value="0" :label="article.visible_accueil == '1' ? 'Visible sur l\'accueil' : 'Masqué sur l\'accueil'" color="green" inset></v-switch>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field v-model="article.date_max" type="date" label="Date de fermeture"></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field v-model="article.quantite" type="number" label="Quantité max globale (0 si pas de limite)"></v-text-field>
      </v-col>
    </v-row>
    <div v-if="article.sizes && article.sizes.length > 0">
      <v-divider class="my-3"></v-divider>
      <div class="text-h6 mb-3">Tailles</div>
      <SizeItem v-for="size in article.sizes" :key="size.id" :item="size"></SizeItem>
    </div>
  </div>
</template>

<script>
import Article_Boutique from "@/classes/Articles/Article_Boutique.class";
import SizeItem from "@/components/Administration/ConfigurationModule/Config_Boutique/Size_Item.vue";

export default {
  components: { SizeItem },
  props: ["item"],
  data() {
    return {
      article: new Article_Boutique(),
    };
  },
  mounted() {
    this.article = this.item;
  },
};
</script>

<style lang="scss" scoped></style>
